import { hrRoutesDictionary } from './hr-routes.dictionary.ts';
import {
  createRoleDataGuard,
  roleUiPermissionGuard,
} from './hr-routes.guards.ts';
import type { RouteRecordRaw } from 'vue-router';

export const hrRoutesConfig: RouteRecordRaw = {
  ...hrRoutesDictionary.hr.root,
  redirect: { name: hrRoutesDictionary.hr.list.name },
  children: [
    {
      ...hrRoutesDictionary.hr.list,
      component: () => import('../pages/List/HrListPage.vue'),
    },
    {
      ...hrRoutesDictionary.hr.create,
      component: () => import('../pages/Create/CreateHrPage/CreateHrPage.vue'),
    },
    {
      ...hrRoutesDictionary.hr.createRole,
      component: () =>
        import('../pages/Create/CreateHrRolePage/CreateHrRolePage.vue'),
      beforeEnter: [roleUiPermissionGuard, createRoleDataGuard],
    },
    {
      ...hrRoutesDictionary.hr.detail,
      component: () => import('../pages/Detail/HrDetailPage.vue'),
      props: true,
    },
    {
      ...hrRoutesDictionary.hr.editAnagraphic,
      component: () =>
        import('../pages/Edit/EditAnagraphicData/EditAnagraphicData.vue'),
      props: true,
    },
    {
      ...hrRoutesDictionary.hr.editAdditionalData,
      component: () =>
        import('../pages/Edit/EditAdditionalData/EditAdditionalData.vue'),
      props: true,
    },
    {
      ...hrRoutesDictionary.hr.editRole,
      component: () => import('../pages/Edit/EditRole/EditRole.vue'),
      props: true,
      beforeEnter: [roleUiPermissionGuard],
    },
  ],
};
